import React, { useEffect } from "react";
import AllRoutes from "./routes";
import Layout from "./layout";
import ExchangeRate from "./components/ExchangeRate";
import { countriesName,countries } from "./utils/CountriesRate";

function App() {
  return (
    <Layout>
      <AllRoutes />
    </Layout>
    // <ExchangeRate countries={countries} countriesName={countriesName}/>
  );
}

export default App;
